import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/tenant`;

export default {
  async acceptInvitation(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/acceptInvitation?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        status: error.status,
        error: true
      };
    }
  },
  async contact(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/contact?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
